window.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.product-family-tree-group:not(.initialized)').forEach(div => {
    div.querySelector('.product-family-tree-group-header').addEventListener('click', e => {
      e.preventDefault();

      div.classList.toggle('open');
    });

    div.classList.add('initialized');
  });
})